import { createSelector } from '@ngrx/store';

import { payloadsFeature } from './payloads.feature';

export const selectPayloadsState = payloadsFeature.selectPayloadsState;
export const selectPayloadsData = createSelector(selectPayloadsState, (s) => s.payloads);
export const selectPayloadsLoading = payloadsFeature.selectLoading;
